<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-share-alt"></i
          ><strong>
            Proceso #{{ $route.params.number }}
            <b-spinner v-if="loading" class="float-right" small></b-spinner>
          </strong>
        </div>
        <b-form @submit="onSubmit" @reset="onReset">
          <b-row>
            <b-col>
              <select-scale class="float-right" size="md" />
              <create-content class="float-right" />
              <create-devolution-content class="float-right" />
              <barcode-scanner @on-scan="addRowsIn($event)" />
              <add-from-stock
                @row-click="addRowsIn($event)"
                :stock_area="$route.params.stockarea_set"
              />
              <process-info />
            </b-col>
          </b-row>
          <hr />
          <b-row class="mt-2">
            <b-col lg="6" md="6" sm="6">
              <content-table
                :title="'Pallets/Bins Volteados'"
                :items="contents_in"
                :footers="footers_in"
                :table_type="0"
                @delete-row="deleteRow($event)"
                :fields="fields"
              >
              </content-table>
            </b-col>
            <b-col lg="6" md="6" sm="6">
              <content-table
                :title="'Pallets/Bins Resultantes'"
                @delete-row="deleteRow($event)"
                :footers="footers_out"
                :table_type="1"
                :items="contents_out"
                :fields="fields"
              >
              </content-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                type="submit"
                :disabled="loading"
                class="float-right"
              >
                <span class="mr-1">Cerrar Proceso</span>
                <b-spinner
                  v-if="loading"
                  variant="light"
                  class="float-right"
                  small
                ></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import ProcessData from "./ProcessData";
import ProcessInfo from "./ProcessInfo";
import ContentTable from "./ContentTable";
import CreateContent from "./CreateContent";
import CreateDevolutionContent from "./CreateDevolutionContent";
import AddFromStock from "./AddFromStock";
import BarcodeScanner from "../../BarcodeScanner";
import selectScale from "../../../views/reusable/selectScale";

import { mapState, mapGetters } from "vuex";

export default {
  name: "MainForm",
  components: {
    ProcessData,
    ProcessInfo,
    ContentTable,
    CreateContent,
    CreateDevolutionContent,
    BarcodeScanner,
    AddFromStock,
    selectScale
  },

  computed: {
    ...mapState("bagnoProcessModule", {
      contents_in: state => state.form.contents_in,
      contents_out: state => state.form.contents_out
    }),
    ...mapGetters("bagnoProcessModule", [
      "totalInNet",
      "totalOutNet",
      "totalInGross",
      "totalOutGross",
      "totalInQuantity",
      "totalOutQuantity",
      "differenceNet"
    ]),
    footers_in() {
      return {
        net_kilograms: this.totalInNet,
        gross_kilograms: this.totalInGross,
        quantity: this.totalInQuantity
      };
    },
    footers_out() {
      return {
        net_kilograms: this.totalOutNet,
        gross_kilograms: this.totalOutGross,
        quantity: this.totalOutQuantity
      };
    }
  },
  created() {
    this.getProcess(this.$route.params.id);
  },
  destroyed() {
    this.$store.commit("bagnoProcessModule/cleanProcess");
  },
  data() {
    return {
      title: "Ingreso",
      loading: false,
      fields: [
        { key: "number", label: "#" },
        { key: "lot", label: "Lote" },
        { key: "product_code", label: "Código" },
        { key: "product", label: "Glosa" },
        {
          key: "quantity",
          label: "Cantidad",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "net_kilograms",
          label: "KN",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "action",
          label: "",
          tdClass: "text-right",
          thClass: "text-right"
        }
      ]
    };
  },
  methods: {
    onSubmit(evt) {
      if (parseFloat(this.differenceNet) == 0) {
        evt.preventDefault();
        this.closeProcess(this.$route.params.id);
      } else {
        this.$toast.info(
          "Por favor la diferencia debe ser 0 para poder cerrar",
          ""
        );
        evt.preventDefault();
      }
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    async getProcess(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `bagno/process/${evt}/detailed_process/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$store.commit("bagnoProcessModule/updateProcess", response.data);
        thisV.$toast.success(`Proceso #${evt} cargado con éxito`, "");
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        thisV.$toast.error("Problemas al cargar proceso", "");
        thisV.loading = false;
      }
    },
    async deleteRow(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      if (evt.table === 0) {
        url = `bagno/process/${evt.item.id}/delete_trace_in/`;
      } else {
        url = `bagno/process/${evt.item.id}/delete_trace_out/`;
      }
      try {
        const response = await thisV.$axios({
          method: "POST",
          url: url,
          data: { process_id: thisV.$route.params.id }
        });
        thisV.$store.commit("bagnoProcessModule/deleteRow", {
          table_type: evt.table,
          item: response.data,
          index: evt.index
        });
        thisV.$toast.success("Eliminado con éxito", "");
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        thisV.$toast.error("Problemas al eliminar item", "");
        thisV.loading = false;
      }
    },
    async addRowsIn(e) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "POST",
          url: `bagno/content/${e}/traceability_in/`,
          data: { process_id: thisV.$route.params.id }
        });
        if (response.data.exist === true) {
          if (thisV.contents_in.find(x => x.id === response.data.id) == null) {
            thisV.$store.commit("bagnoProcessModule/addRowsIn", response.data);
            thisV.$toast.success("Agregado con éxito", "");
            thisV.loading = false;
          } else {
            thisV.$toast.error("Este objeto ya fue ingresado", "");
            thisV.loading = false;
          }
        } else {
          thisV.$toast.error("Este objeto no existe", "");
          thisV.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    },
    async closeProcess(evt) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "POST",
          url: `bagno/process/${evt}/close_process/`
        });
        thisV.$toast.success(
          `Proceso #${response.data.number} terminado con éxito`,
          ""
        );
        thisV.$router.push({ name: "bagno-procesos-listado" });
      } catch (error) {
        console.log(error);
        thisV.$toast.error("Problemas al terminar proceso", "");
        thisV.loading = false;
      }
    }
  }
};
</script>

<style scoped></style>
